<template>
  <div class="pc">
    <div class="title titleMarigin animated bounceInRight">{{titleEn}}</div>
    <div class="title Marigin animated bounceInLeft">{{title}}</div>
    <div class="titleLine"></div>
  </div>
</template>
<script>
export default {
  name: "Title",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    titleEn: {
      type: String,
      default: ""
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 26px;
  color: #000;
  text-align: center;
  font-weight: 800;
  line-height: 42px;
}

.pc{
    margin: 40px 30px 40px;
}

.titleMarigin {
  font-family: MicrosoftYaHei;
  /* color:rgba(24,95,229,1);
  opacity:0.08; */
  color:#eee;
  font-size: 40px;
}
.titleLine{
  background:#235e9d;
  height: 4px;
  width:50px;
  margin:10px auto 0;
}
.Marigin{
  line-height: 28px;
  color:#333;
}
@media screen and (max-width: 750px) {
  .title {
    font-size: 14px;
  }
  .pc{
    margin: 30px 0;
  }
  .titleMarigin{
    font-size:18px;
    line-height:17px;
  }
  .titleLine{
    height: 3px;
    width:30px;
    margin:5px auto 0;
  }
  .Marigin{
    line-height: 14px;
  }
}
</style>